import { CSSObject } from '@chakra-ui/react';
import { TSelected } from './Filters.styles';

export const FlexFilterWrapper: CSSObject = {
  px: '0',
  py: '0',
  my: '3',
  h: '9',
  position: 'inherit',
};

export const ButtonFilter = () => ({
  color: 'alpha.300',
});

export const IconCheck = ({ selected }: TSelected) => ({
  bg: selected ? 'transparent' : 'blackAlpha.500',
  color: selected ? 'beta.300' : 'transparent',
  boxShadow:
    '0px 2px 3px 0px rgba(0, 0, 0, 0.3) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.07)',
});

export const IconRace = ({ selected }: TSelected) => ({
  color: selected ? 'beta.300' : 'blackAlpha.500',
});

export const Divider: CSSObject = {
  bg: 'blackAlpha.400',
  display: 'block',
  h: '7',
  my: 'auto',
  mx: '4',
};

export const TextFilterLabel: CSSObject = {
  color: 'white',
};

export const FlexRaceTypeWrapper: CSSObject = {
  columnGap: '2',
  mr: '0',
};
